import { render, staticRenderFns } from "./StandardItemTags.vue?vue&type=template&id=cb742204&scoped=true&"
import script from "./StandardItemTags.vue?vue&type=script&lang=js&"
export * from "./StandardItemTags.vue?vue&type=script&lang=js&"
import style0 from "./StandardItemTags.vue?vue&type=style&index=0&id=cb742204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb742204",
  null
  
)

export default component.exports